"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateInboundRuleRequest = void 0;
var CreateInboundRuleRequest = /** @class */ (function () {
    function CreateInboundRuleRequest(Rule) {
        this.Rule = Rule;
    }
    return CreateInboundRuleRequest;
}());
exports.CreateInboundRuleRequest = CreateInboundRuleRequest;
//# sourceMappingURL=InboundRule.js.map